import { defineMessages } from 'react-intl';

export const encounterSchemaMessages = defineMessages({
  title: {
    id: 'encounterSchema.title',
    defaultMessage: 'Encounter Schemas',
  },
  createSchema: {
    id: 'encounterSchema.createSchema',
    defaultMessage: 'Create Schema',
  },
  editSchema: {
    id: 'encounterSchema.editSchema',
    defaultMessage: 'Edit Schema',
  },
  name: {
    id: 'encounterSchema.name',
    defaultMessage: 'Name',
  },
  code: {
    id: 'encounterSchema.code',
    defaultMessage: 'Code',
  },
  language: {
    id: 'encounterSchema.language',
    defaultMessage: 'Language',
  },
  description: {
    id: 'encounterSchema.description',
    defaultMessage: 'Description',
  },
  status: {
    id: 'encounterSchema.status',
    defaultMessage: 'Status',
  },
  documents: {
    id: 'encounterSchema.documents',
    defaultMessage: 'Documents',
  },
  save: {
    id: 'encounterSchema.save',
    defaultMessage: 'Save',
  },
  cancel: {
    id: 'encounterSchema.cancel',
    defaultMessage: 'Cancel',
  },
  delete: {
    id: 'encounterSchema.delete',
    defaultMessage: 'Delete',
  },
  deleteConfirm: {
    id: 'encounterSchema.deleteConfirm',
    defaultMessage: 'Are you sure you want to delete this schema?',
  },
  noSchemas: {
    id: 'encounterSchema.noSchemas',
    defaultMessage: 'No encounter schemas yet.',
  },
  addDocument: {
    id: 'encounterSchema.addDocument',
    defaultMessage: 'Add Document',
  },
  removeDocument: {
    id: 'encounterSchema.removeDocument',
    defaultMessage: 'Remove',
  },
  openTemplate: {
    id: 'encounterSchema.openTemplate',
    defaultMessage: 'Open',
  },
  documentCode: {
    id: 'encounterSchema.documentCode',
    defaultMessage: 'Document code',
  },
  inclusion: {
    id: 'encounterSchema.inclusion',
    defaultMessage: 'Inclusion',
  },
  always: {
    id: 'encounterSchema.always',
    defaultMessage: 'Always',
  },
  onDemand: {
    id: 'encounterSchema.onDemand',
    defaultMessage: 'On Demand',
  },
  edit: {
    id: 'encounterSchema.edit',
    defaultMessage: 'Edit',
  },
  view: {
    id: 'encounterSchema.view',
    defaultMessage: 'View',
  },
  actions: {
    id: 'encounterSchema.actions',
    defaultMessage: 'Actions',
  },
  createdAt: {
    id: 'encounterSchema.createdAt',
    defaultMessage: 'Created',
  },
  documentCount: {
    id: 'encounterSchema.documentCount',
    defaultMessage: 'Documents',
  },
  deleteSuccess: {
    id: 'encounterSchema.deleteSuccess',
    defaultMessage: 'Schema deleted successfully',
  },
  deleteError: {
    id: 'encounterSchema.deleteError',
    defaultMessage: 'Failed to delete schema',
  },
  searchPlaceholder: {
    id: 'encounterSchema.searchPlaceholder',
    defaultMessage: 'Search by name...',
  },
  allLanguages: {
    id: 'encounterSchema.allLanguages',
    defaultMessage: 'All languages',
  },
  allStatuses: {
    id: 'encounterSchema.allStatuses',
    defaultMessage: 'All statuses',
  },
  saveSuccess: {
    id: 'encounterSchema.saveSuccess',
    defaultMessage: 'Template saved successfully',
  },
  slotSummary: {
    id: 'encounterSchema.slotSummary',
    defaultMessage: 'Summary',
  },
  slotEvaluation: {
    id: 'encounterSchema.slotEvaluation',
    defaultMessage: 'Evaluation',
  },
  slotLiteratureReview: {
    id: 'encounterSchema.slotLiteratureReview',
    defaultMessage: 'Literature Review',
  },
  slotFollowUp: {
    id: 'encounterSchema.slotFollowUp',
    defaultMessage: 'Follow-up Letter',
  },
  slotNone: {
    id: 'encounterSchema.slotNone',
    defaultMessage: '— None —',
  },
  inclusionAlways: {
    id: 'encounterSchema.inclusionAlways',
    defaultMessage: 'Always',
  },
  inclusionOnDemand: {
    id: 'encounterSchema.inclusionOnDemand',
    defaultMessage: 'On Demand',
  },
  analyticsModelCode: {
    id: 'encounterSchema.analyticsModelCode',
    defaultMessage: 'Tag taxonomy code',
  },
  specialtyTitle: {
    id: 'encounterSchema.specialtyTitle',
    defaultMessage: 'Specialty {name}',
  },
  addTemplate: {
    id: 'encounterSchema.addTemplate',
    defaultMessage: 'Add Template',
  },
  protocolCannotBeAlways: {
    id: 'encounterSchema.protocolCannotBeAlways',
    defaultMessage: 'Protocol templates cannot be marked as always generated',
  },
  tooManyAlwaysDocuments: {
    id: 'encounterSchema.tooManyAlwaysDocuments',
    defaultMessage:
      'Only up to {max} documents can be marked as always generated',
  },
  duplicateDocument: {
    id: 'encounterSchema.duplicateDocument',
    defaultMessage: 'This template is already attached to the schema',
  },
  staffRole: {
    id: 'encounterSchema.staffRole',
    defaultMessage: 'Staff Role',
  },
  alwaysDocuments: {
    id: 'encounterSchema.alwaysDocuments',
    defaultMessage: 'Always Documents',
  },
  onDemandDocuments: {
    id: 'encounterSchema.onDemandDocuments',
    defaultMessage: 'On-Demand Documents',
  },
  noAlwaysDocuments: {
    id: 'encounterSchema.noAlwaysDocuments',
    defaultMessage: 'No always-included documents. Add at least one.',
  },
  noOnDemandDocuments: {
    id: 'encounterSchema.noOnDemandDocuments',
    defaultMessage: 'No on-demand documents.',
  },
  selectTemplate: {
    id: 'encounterSchema.selectTemplate',
    defaultMessage: 'Select template',
  },
  promoteToAlways: {
    id: 'encounterSchema.promoteToAlways',
    defaultMessage: 'Move to Always',
  },
  demoteToOnDemand: {
    id: 'encounterSchema.demoteToOnDemand',
    defaultMessage: 'Move to On Demand',
  },
  tags: {
    id: 'encounterSchema.tags',
    defaultMessage: 'Tags',
  },
  published: {
    id: 'encounterSchema.published',
    defaultMessage: 'Published',
  },
  draft: {
    id: 'encounterSchema.draft',
    defaultMessage: 'Draft',
  },
  namePlaceholder: {
    id: 'encounterSchema.namePlaceholder',
    defaultMessage: 'e.g. Dental Consultation',
  },
  codePlaceholder: {
    id: 'encounterSchema.codePlaceholder',
    defaultMessage: 'e.g. dental-consultation',
  },
  descriptionPlaceholder: {
    id: 'encounterSchema.descriptionPlaceholder',
    defaultMessage: 'Description of this visit type',
  },
  restore: {
    id: 'encounterSchema.restore',
    defaultMessage: 'Restore',
  },
  restoreSuccess: {
    id: 'encounterSchema.restoreSuccess',
    defaultMessage: 'Schema restored successfully',
  },
  restoreError: {
    id: 'encounterSchema.restoreError',
    defaultMessage: 'Failed to restore schema',
  },
  clone: {
    id: 'encounterSchema.clone',
    defaultMessage: 'Clone',
  },
  cloneSuccess: {
    id: 'encounterSchema.cloneSuccess',
    defaultMessage: 'Schema cloned successfully',
  },
  cloneError: {
    id: 'encounterSchema.cloneError',
    defaultMessage: 'Failed to clone schema',
  },
  noDocuments: {
    id: 'encounterSchema.noDocuments',
    defaultMessage: 'No templates attached yet.',
  },
  moveUp: {
    id: 'encounterSchema.moveUp',
    defaultMessage: 'Move up',
  },
  moveDown: {
    id: 'encounterSchema.moveDown',
    defaultMessage: 'Move down',
  },
  saveError: {
    id: 'encounterSchema.saveError',
    defaultMessage: 'Failed to save encounter schema',
  },
  statusObsolete: {
    id: 'encounterSchema.statusObsolete',
    defaultMessage: 'Obsolete',
  },
  languageEnglish: {
    id: 'encounterSchema.languageEnglish',
    defaultMessage: 'English',
  },
  languageRussian: {
    id: 'encounterSchema.languageRussian',
    defaultMessage: 'Russian',
  },
  languageGerman: {
    id: 'encounterSchema.languageGerman',
    defaultMessage: 'German',
  },
  languageSpanish: {
    id: 'encounterSchema.languageSpanish',
    defaultMessage: 'Spanish',
  },
  languagePortuguese: {
    id: 'encounterSchema.languagePortuguese',
    defaultMessage: 'Portuguese',
  },
  addDocumentTitle: {
    id: 'encounterSchema.addDocumentTitle',
    defaultMessage: 'Add Document Template',
  },
  addDocumentSearchPlaceholder: {
    id: 'encounterSchema.addDocumentSearchPlaceholder',
    defaultMessage: 'Search by name, title or description…',
  },
  addDocumentEmpty: {
    id: 'encounterSchema.addDocumentEmpty',
    defaultMessage: 'No document templates available for this language',
  },
  addDocumentNoResults: {
    id: 'encounterSchema.addDocumentNoResults',
    defaultMessage: 'No templates match your search',
  },
  addDocumentGroupOrganization: {
    id: 'encounterSchema.addDocumentGroupOrganization',
    defaultMessage: 'Organization templates',
  },
  addDocumentGroupCommunity: {
    id: 'encounterSchema.addDocumentGroupCommunity',
    defaultMessage: 'Community templates',
  },
  addDocumentGroupSystem: {
    id: 'encounterSchema.addDocumentGroupSystem',
    defaultMessage: 'System templates',
  },
});
